<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
      :multi-line="snackbar.multiline"
      :top="$vuetify.breakpoint.xsOnly"
      app
    >
      <v-icon left :color="snackbar.status">{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          text
          v-bind="attrs"
          @click="CLOSE_SNACKBAR"
        ><v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Snackbar',
  computed: {
    ...mapGetters(['snackbar'])
  },
  methods: {
    ...mapMutations(['CLOSE_SNACKBAR'])
  }
}
</script>

<style>

</style>